import { RequestHelper } from 'utils';
import { API_ROUTES } from 'utils/constants';

const getActivitiesByApplication = () => RequestHelper.GET(API_ROUTES.ACTIVITY());

export const ActivityService = {
  getActivitiesByApplication
};
